document.addEventListener('DOMContentLoaded', function () {
    const wishlistButtons = document.querySelectorAll('.collection-wishlist-btn');
  
    wishlistButtons.forEach(button => {
      const productId = button.getAttribute('data-product-id');
      const productUrl = button.getAttribute('data-product-url');
      const productImage = button.getAttribute('data-image-url');
      const productTitle = button.getAttribute('data-title');
      const variantId = button.getAttribute('data-variant-id');
      const variantSku = button.getAttribute('data-variant-sku');

      const wishlistLinkComponent = Vue.createApp({
        template: `
          <wishlist-link 
            :id="productId" 
            :variant-id="variantId"
            :variant-sku="variantSku"
            :is-product-page="false" 
            type="product" 
            :url="productUrl" 
            :image="productImage" 
            :title="productTitle">
          </wishlist-link>`,
        data() {
          return {
            productId: Number(productId),
            variantId: Number(variantId),
            variantSku: variantSku,
            productUrl: productUrl,
            productImage: productImage,
            productTitle: productTitle,
          };
        },
        components: {
          'wishlist-link': window.wishlistLink 
        }
      });
      wishlistLinkComponent.use(window.store);
      wishlistLinkComponent.mount(button);
    });
  });
